import { on } from '@m2h/common/utils/postMsg';
import { MACHPRO_ALERT_CLOSE } from '@m2h/common/constants/postMsg';
import { isWebAlert } from '@m2h/common/constants';
import {
  closeAlertIframe,
  handleAlertIframePopState,
  isAlertIframeOpen,
} from './iframe';

// export const MACHPRO_ALERT_CLOSE = 'MACHPRO_ALERT_CLOSE';

export const initHistory = () => {
  // if (window.self !== window.top) return;
  if (isWebAlert) return;

  // 监听回退事件
  window.addEventListener('popstate', (e) => {
    if (handleAlertIframePopState()) return;

    if (isAlertIframeOpen()) {
      closeAlertIframe({ fromPopState: true });
      return;
    }
    const backSteps = e?.state?.backSteps;
    if (backSteps) {
      history.go(-backSteps);
    }
  });

  // 父级监听iframe关闭通知
  on(MACHPRO_ALERT_CLOSE, () => closeAlertIframe());
};

class HistoryManager {
  currentIdx: number;
  constructor() {
    this.currentIdx = this.getCurrentIdx();
    this.setupHistoryListener();
  }

  // 获取当前索引
  getCurrentIdx() {
    return window.history.state?.idx || 0;
  }

  // 推送新的历史记录条目
  pushState(url, data = {}) {
    const newIdx = this.currentIdx + 1;
    const state = {
      ...data,
      idx: newIdx,
      timestamp: Date.now()
    };

    window.history.pushState(state, '', url);
    this.currentIdx = newIdx;

    console.log(`📍 推送新历史记录: idx=${newIdx}, url=${url}`);
  }

  // 替换当前历史记录条目
  replaceState(url, data = {}) {
    const state = {
      ...data,
      idx: this.currentIdx,
      timestamp: Date.now()
    };

    window.history.replaceState(state, '', url);
    console.log(`🔄 替换历史记录: idx=${this.currentIdx}, url=${url}`);
  }

  // 监听历史记录变化
  setupHistoryListener() {
    window.addEventListener('popstate', (event) => {
      const newIdx = event.state?.idx || 0;
      const direction = newIdx > this.currentIdx ? 'forward' : 'back';

      console.log(`🔄 历史记录变化: ${this.currentIdx} → ${newIdx} (${direction})`);

      this.currentIdx = newIdx;
      this.onHistoryChange(event.state, direction);
    });
  }

  // 历史记录变化回调
  onHistoryChange(state, direction) {
    console.log('历史记录状态:', state);
    console.log('导航方向:', direction);

    // 可以在这里处理页面状态恢复等逻辑
    if (state?.scrollPosition) {
      window.scrollTo(0, state.scrollPosition);
    }
  }

  // 获取历史记录信息
  getHistoryInfo() {
    return {
      currentIdx: this.currentIdx,
      canGoBack: this.currentIdx > 0,
      canGoForward: window.history.length > this.currentIdx + 1,
      state: window.history.state
    };
  }
}

// // 使用示例
// const historyManager = new HistoryManager();
//
// // 推送新页面
// historyManager.pushState('/page1', {
//   title: 'Page 1',
//   scrollPosition: 0
// });
//
// // 查看历史信息
// console.log(historyManager.getHistoryInfo());
